import connector from "service/connector";


const getPolicy = async () => await
  connector.connectFetchController("policy", "GET");


export { getPolicy };
export default { getPolicy };